var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgErrorCircleFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "qv1uj9w2da"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#qv1uj9w2da)",
    transform: "translate(-54 -722) translate(24 698)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#dd5546",
    d: "M13.333 0c7.364 0 13.334 5.97 13.334 13.333 0 7.364-5.97 13.334-13.334 13.334C5.97 26.667 0 20.697 0 13.333 0 5.97 5.97 0 13.333 0zm0 17.8c-.782 0-1.416.634-1.416 1.417 0 .782.634 1.416 1.416 1.416.783 0 1.417-.634 1.417-1.416 0-.73-.553-1.332-1.262-1.409zm0-11.667c-.552 0-1 .448-1 1v8.334l.01.135c.066.488.484.865.99.865.553 0 1-.448 1-1V7.133l-.009-.135c-.066-.488-.484-.865-.99-.865z",
    transform: "translate(30 24) translate(2.667 2.667)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCircleFilled);
export default __webpack_public_path__ + "static/media/error-circle-filled.12b1569e1205e2c865a37aad500cf438.svg";
export { ForwardRef as ReactComponent };